import React, { useState, useEffect, useRef } from 'react';
import { useLocation, Outlet } from 'react-router-dom';
import PerfectScrollbar from 'perfect-scrollbar';
import AdminNavbar from 'components/Navbars/AdminNavbar';
import Footer from 'components/Footer/Footer';
import Sidebar from 'components/Sidebar/Sidebar';
import routes from 'routes.js';
import logo from 'assets/img/school.png';

const Admin = () => {
  const [backgroundColor, setBackgroundColor] = useState('blue');
  const [sidebarOpened, setSidebarOpened] = useState(false);
  const mainPanelRef = useRef(null);
  const location = useLocation();

  useEffect(() => {
    let ps;
    if (navigator.platform.indexOf('Win') > -1) {
      document.documentElement.classList.add('perfect-scrollbar-on');
      document.documentElement.classList.remove('perfect-scrollbar-off');
      ps = new PerfectScrollbar(mainPanelRef.current, {
        suppressScrollX: true,
        wheelPropagation: false,
      });
    }

    return () => {
      if (ps) ps.destroy();
      document.documentElement.classList.remove('perfect-scrollbar-on');
    };
  }, []);

  useEffect(() => {
    // Scroll to top on route change
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    if (mainPanelRef.current) mainPanelRef.current.scrollTop = 0;
  }, [location]);

  const toggleSidebar = () => {
    document.documentElement.classList.toggle('nav-open');
    setSidebarOpened(!sidebarOpened);
  };

  const getBrandText = () => {
    for (let i = 0; i < routes.length; i++) {
      if (location.pathname.includes(routes[i].layout + '/' + routes[i].path)) {
        return routes[i].name;
      }
    }
    return 'Brand';
  };

  return (
    <div className='wrapper' style={{height:'10px'}}>
      <Sidebar
        routes={routes}
        bgColor={backgroundColor}
        logo={{
          text: 'TN COLLEGE',
          imgSrc: logo,
        }}
        toggleSidebar={toggleSidebar}
      />
      <div className='main-panel' ref={mainPanelRef} data={backgroundColor} style={{ height: '100vh', overflow: 'auto' }}>
        <AdminNavbar
          brandText={getBrandText()}
          toggleSidebar={toggleSidebar}
          sidebarOpened={sidebarOpened}
        />
        <Outlet />
        {location.pathname.includes('maps') ? null : <Footer fluid />}
      </div>
    </div>
  );
};

export default Admin;